import { Autoplay, Controller, EffectFade, Parallax, Navigation, Pagination, Swiper, FreeMode } from 'swiper'
// import { SwiperSlide } from 'swiper/react'
Swiper.use([Autoplay, Controller, EffectFade, Parallax, Navigation, Pagination, FreeMode]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-guide')) {
  page()
}

function page() {
  //  ###    ###  ##   ##
  //  ## #  # ##  ##   ##
  //  ##  ##  ##  ##   ##
  //  ##      ##   ## ##
  //  ##      ##    ###

  if (document.getElementById('guideMv')) {
    // Swiperコンテナを検出したら実行
    const slideCount = slideFix('guideMv', 1.3)
    const sliderName = 'guideMv'
    const guideMvSwiper = new Swiper('#guideMv', {
      init: false, // 自動で初期化しない（guideMvSwiper.init()で初期化）
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 5, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
      spaceBetween: 10, //スライド同士の間隔を空ける
      centeredSlides: true, // 中央のスライドを基準にする
      touchRatio: 1, // タッチスワイプ感度（0でタッチスワイプ無効）
      autoplay: {
        // オートオプション
        delay: 7000, // 待機時間
        disableOnInteraction: false, // 操作されたら停止する
        // pauseOnMouseEnter: true, // マウスオーバー中は一時停止する
        // stopOnLastSlide: true, // 最終スライドに到達したら停止する
      },
      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
      breakpoints: {
        // 指定px以上でオプション切り替え
        769: {
          spaceBetween: 20, //スライド同士の間隔を空ける
        },
      },
    })

    // guideMvSwiper.on('afterInit', function () {
    //   for (let index = 1; index < slideCount; index++) {
    //     setTimeout(() => {
    //       console.log({ index })
    //       console.log({ slideCount })
    //       guideMvSwiper.slidePrev(300)
    //     }, 1000)
    //     // guideMvSwiper.slide(500)
    //   }
    // })
    guideMvSwiper.init()

    // テキスト用のスライド
    slideFix('guideMvText', 1.3)
    const guideMvTextSwiper = new Swiper('#guideMvText', {
      // init: false, // 自動で初期化しない（guideMvTextSwiper.init()で初期化）
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      // fadeEffect: {
      //   // フェードオプション
      //   crossFade: true, // クロスフェード
      // },
    })

    function slideFix(slideName, slideVal) {
      const slideItem = document.getElementById(slideName)

      // 各要素を取得
      const slideWrap = slideItem.querySelector('.swiper-wrapper')
      const slideList = slideItem.querySelectorAll('.swiper-slide')
      let slideCount = slideList.length // スライドの数

      const slidePerViewMax = slideVal * 3 // ループ表示に必要なスライド数　slidesPerViewの3倍
      // ループに不足するスライドを補充する
      while (slideCount < slidePerViewMax) {
        for (const iterator of slideList) {
          const clone = iterator.cloneNode(true)
          slideWrap.appendChild(clone)
          ++slideCount
        }
      }
      return slideCount
    }

    guideMvSwiper.on('slideChangeTransitionStart slideChangeTransitionEnd touchEnd', function (swiper) {
      // console.log(swiper)
      guideMvTextSwiper.slideTo(swiper.realIndex)
    })
  }

  //  #####    #####    ####  ######
  //  ##  ##  ##   ##  ##       ##
  //  #####   ##   ##   ###     ##
  //  ##      ##   ##     ##    ##
  //  ##       #####   ####     ##

  let shopSecSlider = []
  const shopSecSliderItem = document.getElementsByClassName('js-shopSecSlider')
  if (shopSecSliderItem[0]) {
    for (const targetSlider of shopSecSliderItem) {
      const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
      shopSecSliderInit(targetSlider, sliderName)
    }
  }
  function shopSecSliderInit(targetSlider, sliderName) {
    shopSecSlider[sliderName] = new Swiper(targetSlider, {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 800, // アニメ速度
      centeredSlides: true, // 中央のスライドを基準にする
      // loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 1, //表示数変更
      spaceBetween: 15, //スライド同士の間隔を空ける

      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
    })
  }

  //  #####  ##   ##  #####  ##     ##  ######
  //  ##     ##   ##  ##     ####   ##    ##
  //  #####  ##   ##  #####  ##  ## ##    ##
  //  ##      ## ##   ##     ##    ###    ##
  //  #####    ###    #####  ##     ##    ##
  let shopEventSwiper
  if (document.getElementById('shopEvent')) {
    // 片方のデバイスでのみスライダーにする
    if (window.matchMedia('(min-width:769px)').matches) {
      shopEventSwiperInit()
    }
    window.addEventListener('resize', function (e) {
      if (shopEventSwiper && window.matchMedia('(min-width:769px)').matches) {
        shopEventSwiperInit()
      } else if (window.matchMedia('(max-width:768px)').matches) {
        if (shopEventSwiper) {
          shopEventSwiper.destroy()
        }
        shopEventSwiper = false
      }
    })
  }
  function shopEventSwiperInit() {
    const slideItem = document.getElementById('shopEvent')
    const sliderName = 'shopEvent'
    shopEventSwiper = new Swiper(slideItem, {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 'auto', //表示数変更
      spaceBetween: 50, //スライド同士の間隔を空ける
      touchRatio: 0.8, // タッチスワイプ感度（0でタッチスワイプ無効）
      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
    })
  }
}
